import React, { useState, useEffect } from "react";
import PRZLottieT from "@Components/Common/UI/PRZLottieT";

const DocumentDownload = ({ downloadQueue }) => {
  return (
    <div className="document-download__loader-wrapper">
      {Object.values(downloadQueue)?.map((item) => (
        <div className="document-download__loader">
          <div className="document-download__loader-icon">
            <PRZLottieT
              file={'download.json'}
            />
          </div>
          <div className="document-download__loader-text">
            {item?.document_count ? `Downloading ${item?.document_count} ${item?.document_type?.replaceAll('_', ' ')?.toProperCase()}..` : ''}
            {item?.document_number ? `Downloading ${item?.document_type?.replaceAll('_', ' ')?.toProperCase()}..` : ''}
          </div>
        </div>
      ))}
    </div>
  );
};

export default DocumentDownload;
